export class Attachment {
  // types = [
  //     "Monthly Statement",
  //     "Staitment Analysis",
  //     "Cost Analysis",
  //     "Proposal",
  //     "Agreement",
  //     "Agreement - Signed",
  //     "Other"
  // ];

  id: string;
  hash: string;
  label: string;
  filename: string;
  createdAt: Date;
  updatedAt: Date;

  constructor(data: any) {
    this.id = data.id;
    this.hash = data.hash;
    this.label = data.label;
    this.filename = data.filename;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
  }
}
